import { applyFilters, doRequest } from "./helpers";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

export default class ProductLineService {
  static async getTable(filters = null) {
    let path = "/product_line/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getForFilters(filters = null) {
    let path = "/product_line/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async get(id) {
    return doRequest("GET", `/product_line/${id}`);
  }

  static async create(data) {
    return doRequest("POST", "/product_line/", { data: omitBy(data, isNil) });
  }

  static async update(id, data) {
    return doRequest("PUT", `/product_line/${id}`, {
      data: omitBy(data, isNil),
    });
  }

  static async delete(id) {
    return doRequest("DELETE", `/product_line/${id}`);
  }
}
